'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RpcModel = undefined;
exports.createRpcModel = createRpcModel;

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _serverErrors = require('../serverErrors');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Model for rpc request or response
 */
var RpcModel = exports.RpcModel = Nested.Model.extend({
    initialize: function initialize() {
        this.postInitialize();
    },
    postInitialize: function postInitialize() {
        (0, _serverErrors.addServerErrorsIntegration)(this);
    },


    /**
     * integration with nestedTypes
     */
    getStore: function getStore() {
        return this.declaredDomain.getCache().getCacheStore();
    },
    sync: function sync() {
        throw new Error('rpc model can\'t be sync');
    },


    collection: {
        sync: function sync() {
            throw new Error('rpc model collection can\'t be sync');
        }
    }
});

function createRpcModel(className, domain) {
    var protoProps = { className: className, declaredDomain: domain };

    var extendedStaticProps = { className: className, declaredDomain: domain };

    return RpcModel.extend(protoProps, extendedStaticProps);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/rpcModelFactory.js
// module id = 1425
// module chunks = 118